<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-header">
            <h3>Create a new ticket</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <form name="createTicketForm" id="createTicketForm" @submit="submitTicket($event)">
                <div class="col-lg-6">
              <div class="col-lg-12">
                <div class="form-group">
                  <label for="fileSelect">File</label>
                  <select v-validate="'required'" class="form-control" name="fileSelect" v-model="ticketData.file_id" @change="fileChanged($event)">
                      <option v-for="file in fileList" :value="file.id">
                          VIN: {{ file.vin }}  Date: [{{ file.created_at, 'D-M-Y'|dateFilter }}] | {{ file|vehicleDetails}}
                      </option>
                  </select>
                  <span class="text-warning" v-if="errors.has('fileSelect')">
                      You need to select a file
                    </span>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label for="subject">Subject</label>
                  <input
                  v-validate="'required'"
                    name="subject"
                    type="text"
                    class="form-control"
                    v-model="ticketData.subject"
                  />
                  <span class="text-warning" v-if="errors.has('subject')">
                      {{ errors.first('subject') }}
                    </span>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label for="message">Message</label>
                  <textarea v-validate="'required'" name="message" class="form-control" v-model="ticketData.message" />
                  <span class="text-warning" v-if="errors.has('message')">
                      {{ errors.first('message') }}
                    </span>
                </div>
              </div>
               <div class="col-lg-12">
                <div class="form-group">
                    <input type="submit" :disabled="submitDisabled" class="btn btn-primary btn-block" value="Submit">
                </div>
               </div>
              </div>
            </form>
            <div class="col-lg-6">
                <h3>File details</h3>
                <table class="table table-hover" v-if="selectedFile">
              <tbody>
                <tr>
                  <th scope="row">Code</th>
                  <td>{{ selectedFile.code }}</td>
                </tr>
                <tr>
                  <th scope="row">Uploaded at</th>
                  <td>{{ selectedFile.created_at|dateFilter }}</td>
                </tr>
                <tr>
                  <th scope="row">Type of tuning</th>
                  <td>{{ selectedFile.product }} </td>
                </tr>
                <tr>
                  <th scope="row">Enclosed files</th>
                  <td>
                      <ul>
                      <li v-for="file in selectedFile.files">
                           {{ file.name }}
                      </li>
                      </ul>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  props: ["ticketId"],
  components: {
    vueDropzone: vue2Dropzone
  },
  data: function() {
    return {
      ticketData: {
        subject: "",
        message: "",
        file_id: ""
      },
      fileList: {},
      selectedFile: {},
      submitDisabled: false
    };
  },
  mounted: function() {
      this.getFileList();
  },
  methods: {
    goBack() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    getFileList() {
        Webservice.getFileList().then((resp) => {
            if(resp.data) {
                this.fileList = resp.data;
            }
        });
    },
    fileChanged(evt) {
        let selectedId = evt.target.value;
        let selectedFile = _.reject(this.fileList, (file) => {
            return file.id != selectedId;
        });
        if(selectedFile) {
            this.selectedFile = selectedFile[0];
        }
    },
    submitTicket(evt) {
      evt.preventDefault();
      this.$validator.validateAll().then((result) => {
        if (result === true) {
            this.submitDisabled = true;
            Webservice.createTicket(this.ticketData).then((resp) => {
                if(resp.data) {
                    this.$emit("ticketSaved");
                    this.ticketData = { subject: "", message: "", file_id: "" }
                    this.submitDisabled = false;
                    this.$validator.reset();
                    this.$notify({
                        component: {
                        template: '<span>Your ticket has been sent. Please give us some time to answer it.</span>'
                        },
                        icon: 'fas fa-check',
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                    });
                }
            }).catch(error => {
              this.$notify(
                    {
                      component: {
                        template: '<span>Something went wrong. It looks like the ticket data cannot be found. Please contact us if needed.</span>'
                      },
                      icon: 'fas fa-exclamation-triangle',
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'error'
                  });
            });
        } else {
          this.$notify(
              {
                component: {
                  template: '<span>Please make sure you enter all fields</span>'
                },
                icon: 'fas fa-exclamation-circle',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'warning'
              });
        }
      });
    }
  },
  filters: {
    vehicleDetails : function(fileData) {
      var vehicledetails = '';
      if((typeof(fileData.details.vehicle_details) !== 'undefined') && (fileData.details.vehicle_details.brand)) {
        vehicledetails += fileData.details.vehicle_details.brand;
      } else if(fileData.brandName) {
        vehicledetails += fileData.brandName;
      }
      if((typeof(fileData.details.vehicle_details) !== 'undefined') && (fileData.details.vehicle_details.series)) {
        vehicledetails += '  ' + fileData.details.vehicle_details.series;
      } else if(fileData.serieName) {
        vehicledetails += '  ' + fileData.serieName;
      }
      if((typeof(fileData.details.vehicle_details) !== 'undefined') && (fileData.details.vehicle_details.build)) {
        vehicledetails += '  ' + fileData.details.vehicle_details.build;
      } else if(fileData.buildName) {
        vehicledetails += '  ' + fileData.buildName;
      }
      if((typeof(fileData.details.vehicle_details) !== 'undefined') && (fileData.details.vehicle_details.engine)) {
        vehicledetails += '  ' + fileData.details.vehicle_details.engine;
      } else if(fileData.engineName) {
        vehicledetails += '  ' + fileData.engineName;
      }
      return vehicledetails;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/newticket.vue